import {
  getUtcStringWithoutHours,
  getUtcString
} from './../../../utilities/helpers';
import { time } from './../../../data/constants';

const getCommonLabels = () => (sessionStorage.getItem('lng') === 'fr'
  ? require('./../../../labels/labels.french.json')
  : require('./../../../labels/labels.json')).commonLabels;
export function daysDiff(start, end) {
  const diff = (start - end) / time.ONE_DAY_IN_MILLISECONDS;
  return Math.floor(Math.abs(diff));
}

export { getUtcStringWithoutHours, getUtcString };

export function getDatesRange(startDate, endDate) {
  const datesSteps = [];
  let date = startDate.valueOf();
  let lastDate = new Date(getUtcString(endDate)).getTime();
  lastDate -= time.ONE_DAY_IN_MILLISECONDS;
  datesSteps.push(getUtcString(date));
  while (date < lastDate) {
    datesSteps.push(getUtcString((date += time.ONE_DAY_IN_MILLISECONDS)));
  }
  return datesSteps;
}

export function getInputRangeLabels(datesRange) {
  const commonLabels = getCommonLabels();
  return datesRange.map(i => {
    const date = new Date(i);
    const day = date.getUTCDate();
    const month = commonLabels.dates.months[date.getUTCMonth()].substr(0, 3);
    return `${month} ${day}`;
  });
}

export function getInputRangeInit(
  rangeStartDateString,
  rangeEndDateString,
  datesRange
) {
  const min = datesRange.indexOf(rangeStartDateString);
  const max = datesRange.indexOf(rangeEndDateString);
  return { min, max };
}

export function dateToIso(date, returnDayBefore = false) {
  if (!date) return '--';
  let dateTs = new Date(date).getTime();
  if (returnDayBefore) {
    dateTs -= time.ONE_MINUTE_IN_MILLISECONDS;
  }
  return new Date(dateTs).toISOString().substring(0, 10);
}

export function getDaysOfVacation(startDate, endDate, isDisabled) {
  let daysOfVacation;
  if (isDisabled) {
    daysOfVacation = 0;
    return daysOfVacation;
  }
  const vacationStartDate = new Date(startDate).getTime();
  const vacationEndDate = new Date(endDate).getTime();
  daysOfVacation = Math.ceil(
    (vacationEndDate - vacationStartDate + 1) / (1000 * 60 * 60 * 24)
  );
  return daysOfVacation > 1 ? daysOfVacation : daysOfVacation;
}

export function getDayLabel(numberOfDay) {
  const dayLabel = numberOfDay > 1 ? 'days' : 'day';
  return dayLabel;
}
